__turbopack_context__.v({
  "bodyText": "gsxcyq_bodyText",
  "checkItem": "gsxcyq_checkItem",
  "checkItems": "gsxcyq_checkItems",
  "partnershipCallout": "gsxcyq_partnershipCallout",
  "sectionTitle": "gsxcyq_sectionTitle",
  "title": "gsxcyq_title",
  "vitaminAngelsWrapper": "gsxcyq_vitaminAngelsWrapper",
});
